import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const DomiciliationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment-mean--domiciliation']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
